<!-- breadcrumb -->
<div class="container marginMobile">
  <div class="col-sm-12 breadcrumb py-3 m-0">
    <a href="#">Panier</a>
  </div>
</div>
<!-- Fin breadcrumb -->
<!-- Début panier -->
<div class="container">
  <div class="row">
        <div class="col-sm-12 sousTitreRubrique text-center">
           Panier
           <div class="separTitres"></div>
        </div>
  </div>
  <div class="row">
    <div class="table-responsive">
      <table class="table panier">
          <thead>
            <tr>
              <th scope="col"></th>
              <th scope="col">Produit</th>
              <th scope="col">Ref</th>
              <th scope="col">Prix</th>
              <th scope="col">Quantité</th>
              <th scope="col">Total</th>
              <th scope="col">Retirer</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of card; index as i">
              <!-- <app-panier-product [item]="item" ></app-panier-product> -->
              <th scope="row"><div class="text-center"><img onerror="this.onerror=null;this.src='assets/front/images/logo.png';"  height="150px" src="{{baseUrl}}/{{item.product.VIG}}"/></div></th>
              <td class="titleProductCart"><h6>{{item.product.ITMDES1}}</h6></td>
              <td><p>{{item.product.ITMREF}}</p></td>
              <td><p>{{item.product.PRIXNET}} MAD</p></td>
              <td>
                  <div class="col-sm-12 m-0 qteBlocCart text-center">
                  <input type="number" id="quantity" (change)="changeQte($event.target.value,item,i)" name="quantity" min="1" max="100" value="{{item.item_quantity}}">
                 </div>
              </td>
              <td><p>{{item.product.PRIXNET*item.item_quantity}}</p></td>
              <!-- <td><div class="text-center"><img src="assets/front/images/trash-o.png" (click)="removeItem(item.product.ITMREF)" /></div></td> -->
              <td><div class="text-center"><i class="fa fa-trash-o" style="font-size: 22px;" (click)="removeItem(item.product.ITMREF)"></i></div></td>
            </tr>
          </tbody>
        </table>
    </div>
  </div>
  <div class="row Recap" *ngIf="isB2b">
      <div class="col-sm-7">

      </div>
      <div class="col-sm-5">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">RÉCAPITULATIF</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <p class="titlePanier">Total HT : <span class="totalPrice">  {{total}} MAD</span></p>
                <p class="titlePanier">TVA (20%) : <span class="totalPrice">  {{tva}} MAD</span></p>
                <p class="titlePanierTotal">Total à payer : <span class="totalPricefin"> {{total+tva}} MAD</span></p>
              </td>
            </tr>
            <!-- <tr>
              <td>
                <ul class="livraisonText">
                  <li>Livraison gratuite Si la commande est Supérieure à 1000 Dhs et à casa seulement</li>
                  <li>Livraison 50 DH Si la commande est Inferieure à 1000 Dhs et à casa seulement</li>
                  <li>Frais AMANA PAYER PAR LE CLIENT Si la commande est Hors casa</li>
                </ul>
              </td>
            </tr> -->
            <tr>
              <td>
                <ul class="livraisonText">
                  <!-- <li>Livraison gratuite Si la commande est Supérieure à 1000 Dhs et à casa seulement</li>
                  <li>Livraison 50 DH Si la commande est Inferieure à 1000 Dhs et à casa seulement</li>
                  <li>Frais AMANA PAYER PAR LE CLIENT Si la commande est Hors casa</li> -->
                  <li>Les frais de livraison sont calculés lors du paiement.</li>
                  <li>Le retrait en magasin est gratuit.</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>
                <h6>Moyen de paiement </h6>
              </td>
            </tr>
            <tr>
              <td class="check">
                <!-- <div class="form-check">
                  <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1">
                  <label class="form-check-label" for="flexRadioDefault1">
                    CARTE BANCAIRE
                  </label>
                </div> -->
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" checked>
                  <label class="form-check-label" for="flexRadioDefault2">
                    Paiement en espèces à la livraison pour commande supérieur à 1000 Dhs à Casablanca. 
                  </label>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
  </div>
  <div class="row Recap" *ngIf="!isB2b">
    <div class="col-sm-7">

    </div>
    <div class="col-sm-5">
      <table class="table">
        <thead>
          <tr>
            <th scope="col">RÉCAPITULATIF</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <p class="titlePanier">Total TTC : <span class="totalPrice">  {{total}} MAD</span></p>
              <p class="titlePanier">TVA (20%) : <span class="totalPrice">  {{tva}} MAD</span></p>
              <p class="titlePanierTotal">Total à payer : <span class="totalPricefin"> {{total+tva}} MAD</span></p>
            </td>
          </tr>
          <tr>
            <td>
              <ul class="livraisonText">
                <!-- <li>Livraison gratuite Si la commande est Supérieure à 1000 Dhs et à casa seulement</li>
                <li>Livraison 50 DH Si la commande est Inferieure à 1000 Dhs et à casa seulement</li>
                <li>Frais AMANA PAYER PAR LE CLIENT Si la commande est Hors casa</li> -->
                <li>Les frais de livraison sont calculés lors du paiement.</li>
                <li>Le retrait en magasin est gratuit.</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td>
              <h6>Moyen de paiement </h6>
            </td>
          </tr>
          <tr>
            <td class="check">
              <!-- <div class="form-check">
                <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1">
                <label class="form-check-label" for="flexRadioDefault1">
                  CARTE BANCAIRE
                </label>
              </div> -->
              <div class="form-check">
                <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" checked>
                <label class="form-check-label" for="flexRadioDefault2">
                Paiement en espèces à la livraison pour commande supérieur à 1000 Dhs à Casablanca. 
                </label>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
</div>
  <div class="row actionsCart">
      <div class="col-sm-12">
        <a *ngIf="total+tva > 0" routerLink="/confirmation" >
          <button class="btn actionBtn checkOrder" name="button"  >Valider la commande</button>
        </a>
        <a *ngIf="total+tva == 0"  >
          <button class="btn actionBtn checkOrder" name="button" disabled >Valider la commande</button>
        </a>
          <!-- <button class="btn actionBtn cartUpdate" name="button" >Mettre à jour le panier</button>
          <button class="btn actionBtn poursuiveAchat" name="button" >Poursuivre vos achats</button>
          <button class="btn actionBtn creerDevis" name="button" >Créer devis</button> -->

      </div>

  </div>
</div>
<!-- Fin panier -->
